if (!customElements.get('pop-up')) {
  customElements.define('pop-up', class PopUp extends HTMLElement {
    constructor() {
      super();

      this.closeButton = this.querySelector('.pop-up--close-button')
      this.sectionId = this.dataset.section;

      this.closeButton.addEventListener('click', this.onClickHandler.bind(this));

      if(!sessionStorage.getItem(`disable-popup-${this.sectionId}`)) {
        setTimeout(() => {
          this.classList.add('active');
        }, 3000);
      }
    }

    onClickHandler(event) {
      sessionStorage.setItem(`disable-popup-${this.sectionId}`, true);
      this.classList.remove('active');
    }
  });
}
